class Keyword {

  constructor (data) {
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    return data
  }
}

export {
  Keyword as default
}



// WEBPACK FOOTER //
// ./src/models/keyword.js